import React, { useState } from "react";
import { Phone, X, AlertTriangle, MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";

const QUICK = [
  { id: "999", label: "999 Emergency", phone: "999", tone: "bg-red-600 hover:bg-red-700" },
  { id: "111", label: "NHS 111", phone: "111", tone: "bg-teal-700 hover:bg-teal-800" },
  { id: "samaritans", label: "Samaritans", phone: "116123", tone: "bg-teal-700 hover:bg-teal-800" },
];

export default function CrisisBar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="crisis-bar-trigger"
        onClick={() => setOpen(true)}
        className="fixed bottom-24 left-4 md:left-6 md:bottom-6 z-50 bg-red-600 hover:bg-red-700 text-white rounded-full pl-4 pr-5 py-3 shadow-lg flex items-center gap-2 font-semibold transition-transform hover:scale-[0.98]"
      >
        <AlertTriangle className="w-5 h-5" />
        {t("crisis_bar.trigger")}
      </button>

      {open && (
        <div className="fixed inset-0 z-50 bg-slate-900/60 flex items-end md:items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="crisis-bar-overlay">
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl fade-up">
            <div className="flex items-start justify-between mb-2">
              <div>
                <h2 className="font-display text-xl font-bold text-slate-900">{t("crisis_bar.title")}</h2>
                <p className="text-sm text-slate-500 mt-1">{t("crisis_bar.subtitle")}</p>
              </div>
              <button data-testid="crisis-bar-close" onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-2 mt-4">
              {QUICK.map((c) => (
                <a
                  key={c.id}
                  data-testid={`crisis-call-${c.id}`}
                  href={`tel:${c.phone}`}
                  className={`flex items-center justify-between text-white rounded-xl px-4 py-3 font-medium ${c.tone}`}
                >
                  <span>{c.label}</span>
                  <span className="flex items-center gap-2 opacity-90"><Phone className="w-4 h-4" /> {c.phone}</span>
                </a>
              ))}
              <a
                data-testid="crisis-text-shout"
                href="sms:85258&body=SHOUT"
                className="flex items-center justify-between bg-slate-900 hover:bg-slate-800 text-white rounded-xl px-4 py-3 font-medium"
              >
                <span className="flex items-center gap-2"><MessageSquare className="w-4 h-4" /> {t("crisis_bar.text_shout")}</span>
                <span className="opacity-90">85258</span>
              </a>
            </div>

            <p className="text-xs text-slate-500 mt-4">{t("crisis_bar.footer")}</p>
          </div>
        </div>
      )}
    </>
  );
}
